<template>
    <div style="background: white">
        <!-- <div class="bannerBox">
            <a-carousel :dot-position="bottom">
                <div>
                    <img class="bannerImg" src="@/assets/img/kjcg-jsht.jpg" />
                </div>
            </a-carousel>
        </div> -->
        <div class="breadBox">
            <a-breadcrumb>
                <span>
                    <img src="@/assets/img/position.png" />
                    当前位置：
                </span>
                <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
                <a-breadcrumb-item>{{title}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="tabBox">
            <div class="content" v-html="FlowContent"></div>
        </div>
    </div>
</template>
<script>
import { achievementFontInfo } from "@/api/achievementsService";

export default {
    name: "noticeDetail",
    components: { },
    data() {
        return {
            title: null,
            noticeObj: {},
            FlowContent:""
        }
    },
    methods: {
        getDetail(e) {
            this.getAction({
                url: achievementFontInfo.detailFlow,
                params: { tags: e }
            }).then(res => {
               this.FlowContent = res.content
            })
        },
        onRollbackHome() {
            this.$router.push({
                path: "/knowledge/index",
                query: {
                    type: "首页"
                }
            })
        }
    },
    mounted() {
        this.title = this.$route.query.type
        this.getDetail(this.$route.query.queryData)
    }
}
</script>
<style lang="less" scoped>
.bannerBox {
    position: relative;
    width: 100%;
    //margin-bottom: 20px;

    .bannerImg {
        width: 100%;
        height: 100%;
    }
}

.breadBox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    background: white;
}

.tabBox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0 20px 0;

    .title {
        text-align: center;
        font-size: 30px;
        color: #333;
    }

    .subtitle {
        font-size: 14px;
        text-align: center;
        margin-top: 30px;
        padding-bottom: 20px;
        color: #333;
        border-bottom: 1px solid #ccc;
    }

    .titlecontent {
        text-align: center;
        font-size: 16px;
        margin-top: 60px;
        font-weight: 600;
    }

    .content {
        font-size: 16px;
        line-height: 30px;
        margin-top: 60px;
        text-indent: 30px;
    }
}
</style>
